"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterMultiSelect = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireWildcard(require("react"));
var _MultiSelect = require("../multi-select/MultiSelect");
var _filterArrow = require("../../../assets/icons/filter-arrow.svg");
var _filterMultiSelectModule = _interopRequireDefault(require("./filter-multi-select.module.scss"));
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _excluded = ["filterName", "noValueLabel", "allValuesLabel"];
var FilterMultiSelect = function FilterMultiSelect(_ref) {
  var filterName = _ref.filterName,
    noValueLabel = _ref.noValueLabel,
    allValuesLabel = _ref.allValuesLabel,
    multiSelectProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var valueRenderer = (0, _react.useCallback)(function (selectedOptions) {
    var isAllSelected = selectedOptions.length === multiSelectProps.options.length;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: _filterMultiSelectModule.default['filter-multi-select__filter-name']
    }, filterName, ":"), /*#__PURE__*/_react.default.createElement("span", {
      className: _filterMultiSelectModule.default['filter-multi-select__value']
    }, isAllSelected && allValuesLabel ? allValuesLabel : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, selectedOptions[0] ? selectedOptions[0].label : noValueLabel, ' ', selectedOptions.length > 1 && t('filterMultiSelect.andMore', {
      count: selectedOptions.length - 1
    }))));
  }, [filterName, noValueLabel, allValuesLabel, multiSelectProps.options.length, t]);
  return /*#__PURE__*/_react.default.createElement(_MultiSelect.MultiSelect, Object.assign({}, multiSelectProps, {
    icon: /*#__PURE__*/_react.default.createElement(_filterArrow.ReactComponent, null),
    valueRenderer: valueRenderer
  }));
};
exports.FilterMultiSelect = FilterMultiSelect;